import e from "../managers/braze-instance.js";
import dt from "./utils/push-utils.js";
export function isPushSupported() {
  if (e.rr()) return dt.isPushSupported();
}
